// extracted by mini-css-extract-plugin
module.exports = {"newTag":"video-buttons_newTag_3i9"};